var SeriesGallery = class {
    _findActive() {
        let activeEl = this.element.querySelector(this.activeClass);
        let sid = parseInt(activeEl.dataset.sid);

        return sid;
    }
    _initSwiper() {
        let startPos = this._findActive()

        this.owl = $(".owl-carousel").owlCarousel({
            nav: true,
            items: 4,
            slideBy: 4,
            dots: true,
            navElement: 'span',
            navText: '',
            responsiveClass: true,
            startPosition: startPos,
            responsive: {
                0 : {
                    items: 1,
                    autoWidth: true,
                    margin: 20
                },
                768 : {
                    items: 3
                },
                1000 : {
                    items: 4
                }
            }
        });
    }

    constructor(wrapper) {
        this.element = wrapper;
        this.activeClass = '.thumbGallery-series_slide-active';

        this._initSwiper();
    }
};


export default SeriesGallery;